export default __webpack_public_path__ + "static/937-08efbe468cc727f573f086fcd3daa243.gif";